module.exports = __webpack_public_path__ + "img/top side seam.f4c847e3.png";